import { Controller } from "@hotwired/stimulus"
import { useTransition } from "stimulus-use"

// Local toast controller (railsui-stimulus + optional auto-dismiss ms).
export default class extends Controller {
  static values = {
    triggerOnLoad: { type: Boolean, default: false },
    autoDismissMs: { type: Number, default: 0 },
    removeOnHide: { type: Boolean, default: false },
  }

  connect() {
    // useTransition chains toggleTransition if wired twice on a reused instance (Turbo reconnect).
    if (!this.transitionWired) {
      useTransition(this, {
        element: this.element,
      })
      this.transitionWired = true
    }

    if (this.triggerOnLoadValue) {
      this.enter()
    }

    this.scheduleAutoDismiss()
  }

  disconnect() {
    this.clearAutoDismiss()
    if (this.transitioned) this.leave()
  }

  toggle() {
    this.toggleTransition()
  }

  async hide() {
    this.clearAutoDismiss()
    await this.leave()
    if (this.removeOnHideValue) this.element.remove()
  }

  scheduleAutoDismiss() {
    this.clearAutoDismiss()
    if (this.autoDismissMsValue <= 0) return

    this.autoDismissTimer = window.setTimeout(() => {
      this.autoDismissTimer = null
      this.hide()
    }, this.autoDismissMsValue)
  }

  clearAutoDismiss() {
    if (this.autoDismissTimer == null) return

    window.clearTimeout(this.autoDismissTimer)
    this.autoDismissTimer = null
  }
}
